import { Box, Stack, lighten, useTheme } from "@mui/material";
import React from "react";
import Image from "next/image";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { TSlide } from "./types";

export function Thumbnail(props: {
  slide: TSlide;
  isSelected?: boolean;
  onClick?: (s: TSlide) => void;
}) {
  const theme = useTheme();
  const { sm: smUp, md: mdUp } = useCssMediaQuery("up");
  const { images } = useTeamConfig();

  return (
    <Box
      onClick={() => props?.onClick?.(props.slide)}
      sx={{
        width: "100%",
        height: smUp ? "48px" : "32px",
        overflow: "hidden",
        borderRadius: 0.5,
        position: "relative",
        transition: "box-shadow 0.2s ease-in-out",
        cursor: props?.isSelected ? "default" : "pointer",
        outline: props.isSelected ? "2px solid" : "1px solid",
        outlineColor: props.isSelected
          ? theme.palette.primary.main
          : theme.palette.divider,
        boxShadow: props.isSelected
          ? `0 0 0 6px ${lighten(theme.palette.primary.main, 0.8)}`
          : "none",
        pointerEvents: props.isSelected ? "none" : "auto",
        "&:hover": {
          boxShadow: !props?.isSelected
            ? `0 0 0 4px ${lighten(theme.palette.primary.main, 0.8)}`
            : `0 0 0 6px ${lighten(theme.palette.primary.main, 0.8)}`,
        },
      }}
    >
      {props?.slide.type === "2d" ? (
        <Stack
          position={"absolute"}
          top={0}
          left={0}
          width={"100%"}
          height={"100%"}
          zIndex={1}
          color={theme.palette.common.black}
          bgcolor={theme.palette.grey[200]}
          justifyContent={"center"}
          alignItems={"center"}
          fontWeight={"bold"}
          textAlign={"center"}
          lineHeight={"1"}
          fontSize={mdUp ? "0.9rem" : smUp ? "0.9rem" : "0.7rem"}
          p={1}
          sx={{
            backdropFilter: "blur(1px)",
          }}
        >
          Ticket Group
        </Stack>
      ) : null}

      {props.slide.type === "3d" ? (
        <>
          <Image
            alt="3d view"
            width={2568}
            height={1445}
            src={images?.seatMap3dPreviewImage}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <Stack
            position={"absolute"}
            top={0}
            left={0}
            width={"100%"}
            height={"100%"}
            zIndex={1}
            color={theme.palette.common.white}
            justifyContent={"center"}
            alignItems={"center"}
            fontWeight={"bold"}
            sx={{
              backdropFilter: "blur(1px)",
            }}
          >
            3d
          </Stack>
        </>
      ) : null}
      {props.slide.type === "image" ? (
        <Image
          src={props.slide.component.props.src}
          alt="suite"
          width={2568}
          height={1445}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : null}
    </Box>
  );
}
